<style lang="less">
@import "../node_modules/uikit/src/less/uikit.less";
@import "./App.less";
</style>

<template>
  <div id="app">
    <div class="root-container-height root-container-height-family">
      <template v-if="showLoadingSpinner">
        <div class="uk-flex uk-flex-center uk-height-1-1 and uk-width-1-1">
          <BouncingPreloader :marginTop="304" :hideLoadingText="true" />
        </div>
      </template>
      <template v-else>
        <router-view class="main-height" />
      </template>
    </div>

    <error-popup
      v-on:showErrorPopup="showErrorPopup($event)"
      :errorResponse="errorResponse"
    ></error-popup>
  </div>
</template>
<script>
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import "@/assets/fonts/montserrat-font.css";
import ErrorPopUpComponent from "@/commoncomponents/errorpopupcomponent/ErrorPopUpComponent.vue";
import "normalize.css/normalize.css";
import "./styles/cover.less";
import "./styles/index.less";
import APP_UTILITIES from "./utilities/commonFunctions";
import BouncingPreloader from "./commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import { GlobalModule } from "@/store/global/globalModule";
import commonEntry from "./store/modules/commonEntry";
import APP_CONST from "./constants/AppConst";
import { ApiErrorType } from "./Model/error/api/types";
import { getInstance } from "./auth";
import * as LDClient from "launchdarkly-js-client-sdk";

UIkit.use(Icons);
export default {
  name: "App",
  data() {
    return {
      errorResponse: {},
      globalModule: getModule(GlobalModule, store),
    };
  },
  components: {
    BouncingPreloader,
    "error-popup": ErrorPopUpComponent,
  },
  computed: {
    isFetchingAccountDetailsBySlug() {
      return commonEntry.isFetchingAccountDetailsBySlug;
    },
    isInitialAccountDetailsBySlugFetch() {
      return commonEntry.isInitialAccountDetailsBySlugFetch;
    },
    isFetchingUserDetails() {
      return commonEntry.isFetchingUserDetails;
    },
    isInitialUserDetailsFetch() {
      return commonEntry.isInitialUserDetailsFetch;
    },
    showLoadingSpinner() {
      return (
        (this.isFetchingAccountDetailsBySlug &&
          this.isInitialAccountDetailsBySlugFetch) ||
        this.didFetchAccountDetailsBySlugFail ||
        this.didFetchUserDetailsFail
      );
    },
    didFetchAccountDetailsBySlugFail() {
      return commonEntry.didFetchAccountDetailsBySlugFail;
    },
    didFetchUserDetailsFail() {
      return commonEntry.didFetchUserDetailsFail;
    },
  },
  created() {
    this.$eventHub.$on("showErrorPopup", this.showErrorPopup);
    this.onCreated();
  },
  methods: {
    async onCreated() {
      const authService = getInstance();
      if (authService.loading) {
        authService.$watch("loading", async (loading) => {
          if (!loading && !["/logout/"].includes(window.location.pathname)) {
            const slug = APP_UTILITIES.accountSlug;
            const userId = APP_UTILITIES.getCookie(APP_CONST.USER_ID);
            const apiRequests = [commonEntry.getAccountDetailsBySlug(slug)];
            if (userId) {
              const fetchUserDetails = commonEntry.fetchUserDetails(
                Number(userId)
              );
              apiRequests.push(fetchUserDetails);
            }
            await Promise.all(apiRequests);
            this.addfavIcon();
          }
        });
      }
    },
    showErrorPopup(error) {
      const supressGlobalErrorPopup = this.globalModule.supressGlobalErrorPopup;
      if (error && supressGlobalErrorPopup === false) {
        this.errorResponse = {
          name: error.name,
        };
      }
    },
    addfavIcon() {
      setTimeout(() => {
        let accDesign = APP_UTILITIES.getCookie("accountDesign") || "";
        accDesign = accDesign && JSON.parse(accDesign);
        if (accDesign && accDesign.faviconUrl) {
          const link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = accDesign.faviconUrl;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }, 1000);
    },
    handleFetchDetailsFailedError(errorStateProp) {
      if (
        errorStateProp &&
        errorStateProp.name !== ApiErrorType.Error_Unauthorized
      ) {
        const isUnknown =
          errorStateProp && errorStateProp.name === ApiErrorType.Error_Unknown;
        const error = isUnknown ? { name: "Common_Error" } : errorStateProp;
        this.$eventHub.$emit("showErrorPopup", error);
      }
    },
    async initLaunchDarkly() {
      const context = {
        kind: "user",
        key: APP_UTILITIES.getCookie(APP_CONST.USER_ID)
      };
      try {
        const client = LDClient.initialize(
          process.env.VUE_APP_LD_CLIENT_ID,
          context
        );
        await client.waitForInitialization();
        APP_UTILITIES.setLDClient(client);
      } catch (error) {
        console.error("Error initializing LaunchDarkly:", error);
      }
    },
    async beforeMount() {
      await this.initLaunchDarkly();
    },
  },
  watch: {
    didFetchAccountDetailsBySlugFail(didFail) {
      if (didFail) {
        this.handleFetchDetailsFailedError(
          commonEntry.fetchAccountDetailsBySlugFailedError
        );
      }
    },
    didFetchUserDetailsFail(didFail) {
      if (didFail) {
        this.handleFetchDetailsFailedError(
          commonEntry.fetchUserDetailsFailedError
        );
      }
    },
  },
};
</script>
